import { Helmet } from "react-helmet-async";
import { SITE_URL } from "../lib/site";

export const Seo = ({ title, description, path = "/", jsonLd }) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    {SITE_URL && <link rel="canonical" href={`${SITE_URL}${path}`} />}
    {SITE_URL && <meta property="og:url" content={`${SITE_URL}${path}`} />}
    {(jsonLd || []).map((j, i) => (
      <script key={i} type="application/ld+json">{JSON.stringify(j)}</script>
    ))}
  </Helmet>
);
